require('select2');

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// window.onload = function () {
// const app = new Vue({
//     el: '#app',
// });
// }


WebFont.load({
    google: { families: ["Open Sans:300,300italic,400,400italic,600,600italic,700,700italic,800,800italic", "Roboto:300,regular,500"] }
});

!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip(
        { boundary: 'window', container: 'body' }
    );
    $('select.select2').select2({width: '100%'});
    $('select.select2-ajax').each(function() {

        var coupling = false;
        if( $(this).data('get-items-field')=='case_list_belongsto_employee_relationship_1' ||
            $(this).data('get-items-field')=='case_list_belongsto_employee_relationship_2' ||
            $(this).data('get-items-field')=='case_list_belongsto_employee_relationship_3'
        ){
            coupling = true;
        }

        var $this = this;

        var opt = {
            width: '100%',
            ajax: {
                url: $(this).data('get-items-route'),
                data: function (params) {
                    var query = {
                        search: params.term,
                        type: $(this).data('get-items-field'),
                        method: $(this).data('method'),
                        id: $(this).data('id'),
                        page: params.page || 1
                    }
                    return query;
                },
                processResults: function(data){
                    if(coupling){
                        var emp_coupling_id = [];

                        // 非主辦律師
                        if($($this).attr('name')!=='contract_lawyer'){
                            if($('select[name="contract_lawyer"]').val()){
                                emp_coupling_id = emp_coupling_id.concat([$('select[name="contract_lawyer"]').val().toString()])
                            }
                        }

                        // 非協辦律師
                        if($($this).attr('name')!=='case_list_belongsto_employee_relationship_2[]'){
                            emp_coupling_id = emp_coupling_id.concat($('select[name="case_list_belongsto_employee_relationship_2[]"]').val())
                        }

                        // 非助理
                        if($($this).attr('name')!=='case_list_belongsto_employee_relationship_3[]'){
                            emp_coupling_id = emp_coupling_id.concat($('select[name="case_list_belongsto_employee_relationship_3[]"]').val())
                        }

                        emp_coupling_id = emp_coupling_id.filter(function (value, index, self) { 
                            return self.indexOf(value) == index;
                        })

                        data.results = data.results.filter(function (value, index, self) {
                            return !emp_coupling_id.includes(value.id.toString())
                        })
                    }
                    return data;
                }
            },
        };

        if(!isNaN($(this).data('maximum')) && $(this).data('maximum') > 0){
            opt.maximumSelectionLength=$(this).data('maximum');
            opt.language={
                maximumSelected: function(args) {return '最多選擇 ' + args.maximum + ' 位'}
            }
        }

        $(this).select2(opt);

        $(this).on('select2:select',function(e){
            var data = e.params.data;
            if (data.id == '') {
                // "None" was selected. Clear all selected options
                $(this).val([]).trigger('change');
            } else {
                $(e.currentTarget).find("option[value='" + data.id + "']").attr('selected','selected');
            }
        });

        $(this).on('select2:unselect',function(e){
            var data = e.params.data;
            $(e.currentTarget).find("option[value='" + data.id + "']").attr('selected',false);
        });
    });
    $('select.select2-taggable').select2({
        width: '100%',
        tags: true,
        createTag: function(params) {
            var term = $.trim(params.term);

            if (term === '') {
                return null;
            }

            return {
                id: term,
                text: term,
                newTag: true
            }
        }
    }).on('select2:selecting', function(e) {
        var $el = $(this);
        var route = $el.data('route');
        var label = $el.data('label');
        var errorMessage = $el.data('error-message');
        var newTag = e.params.args.data.newTag;

        if (!newTag) return;

        $el.select2('close');

        $.post(route, {
            [label]: e.params.args.data.text,
            _tagging: true,
        }).done(function(data) {
            var newOption = new Option(e.params.args.data.text, data.data.id, false, true);
            $el.append(newOption).trigger('change');
        }).fail(function(error) {
            toastr.error(errorMessage);
        });

        return false;
    }).on('select2:select', function (e) {
        if (e.params.data.id == '') {
            // "None" was selected. Clear all selected options
            $(this).val([]).trigger('change');
        }
    });
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

window.toCurrency = function(num){
    if(isNaN(num)){
        return num;
    }

    var parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}

window.alertModal=function(title='', context='',size='md', callback=null){
    $('#alertModalTitle').text(title);
    $('#alertModalBody').html(context);

    var className='';
    switch(size){
        case 'xl': className='modal-xl'; break;
        case 'lg': className='modal-lg'; break;
    }
    $('#alertModal .modal-dialog').removeClass('modal-lg modal-xl').addClass(className);
    $('#alertModal').modal('show');

    $('#alertModal').off('hidden.bs.modal');
    $('#alertModal').on('hidden.bs.modal', function(e) {
        if(callback!=null){
            callback();
        }
    })
}

window.confirmModal=function(title='', context='',size='md',callback=null, alwaysCB=null){
    $('#confirmModalTitle').text(title);
    $('#confirmModalBody').html(context);

    var className='';
    switch(size){
        case 'xl': className='modal-xl'; break;
        case 'lg': className='modal-lg'; break;
    }
    $('#confirmModal .modal-dialog').removeClass('modal-lg modal-xl').addClass(className);
    $('#confirmModal').modal('show');

    $('#confirm_ok').off('click')
    $('#confirm_ok').on('click', function() {
        if(callback!=null){
            callback();
        }
    })
    $('#confirmModal').off('hidden.bs.modal');
    $('#confirmModal').on('hidden.bs.modal', function(e) {
        if(alwaysCB!=null){
            alwaysCB();
        }
    })
}

$(document).on('hidden.bs.modal', '.modal', function () {
    $('.modal:visible').length && $(document.body).addClass('modal-open');
});
